import { PublicVideoCards } from '@wix/wix-vod-api-site-based/dist/src/public/services/video-cards/video-cards';
import { parseCards } from '@wix/wix-vod-shared/dist/src/common/parsers/cards/cards';
import { toError } from 'api/parsers/transport-error';
import { publicCatalogServiceConfig } from 'api/config/catalog-service';

const service = new PublicVideoCards(publicCatalogServiceConfig);

export const getVideoCards = (channelId, videoId) =>
  service
    .getList(channelId, videoId)
    .then(response => ({
      ...response,
      data: parseCards(response.data),
    }))
    .catch(toError);
